module.exports = __webpack_public_path__ + "assets/img/title-6fb2500d.png";